import React from 'react';
import { AppBar, Toolbar, Typography, Button, IconButton, Stack, Box, Tooltip } from '@mui/material';
import { Person } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

export default function LandingPageLayoutDesktop({ children }) {
  const navigate = useNavigate();
  const sections = ['hero', 'problema', 'soluzioni', 'testimonianze', 'prezzi','contatti', 'accedi','registrati'];

  const scrollToSection = (id) => {
    if (id === 'accedi') {
      navigate('/login');
    }else if (id === 'registrati') {
                     navigate('/register');
    } else {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Box sx={{ fontFamily: 'Arial, sans-serif', color: '#A8E6CF' }}>
      <AppBar position="fixed" color="primary" sx={{ bgcolor: '#A8E6CF' }}>
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography sx={{ color: '#2742F5' }} variant="h4">
            DeskStudio
          </Typography>
          <Stack direction="row" spacing={2}>
            {sections.map((sec) => (
              <React.Fragment key={sec}>
                {sec === 'accediii' ? (
                  <Tooltip title="Accedi">
                    <IconButton
                      sx={{ bgcolor: '#56C596', color: '#fff' }}
                      aria-label="Accedi"
                      onClick={() => scrollToSection(sec)}
                      size="large"
                    >
                      <Person />
                    </IconButton>
                  </Tooltip>
                ) : (
                  <Button sx={{ color: '#2742F5' }} onClick={() => scrollToSection(sec)}>
                    {sec.charAt(0).toUpperCase() + sec.slice(1)}
                  </Button>
                )}
              </React.Fragment>
            ))}
          </Stack>
        </Toolbar>
      </AppBar>
      <Box sx={{ mt: 8 }}>{children}</Box>
    </Box>
  );
}
